import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
//角色标识
export function setRole(slug) {
  return Cookies.set('roleSlug',slug)
}
export function getRole() {
  return Cookies.get('roleSlug')
}
export function removeRole() {
  return Cookies.remove('roleSlug')
}
// 用户id
export function setUser(userId) {
  return Cookies.set('userId', userId)
}
export function getUser() {
  return Cookies.get('userId')
}
export function removeUser() {
  return Cookies.remove('userId')
}

// 用户id
export function setUserName(userName) {
  return Cookies.set('userName', userName)
}
export function getUserName() {
  return Cookies.get('userName')
}
export function removeUserName() {
  return Cookies.remove('userName')
}


